import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../reducers/painelAlerta.actions";
import {
  getFiltros,
  getOs,
} from "../../../../selectors/painelAlerta.selectors";
import Header from "./Header";

const HeaderConnected = () => {
  const dispatch = useDispatch();
  const filtros = useSelector(getFiltros);
  const osFile = useSelector(getOs);

  const handleClickOpenFilters = useCallback(() => {
    dispatch(actions.exibirFiltros(true));
  }, [dispatch]);

  const handleDownloadCsv = useCallback(() => {
    dispatch(actions.downloadOs.request());
  }, [dispatch]);

  const handleCleanOsData = useCallback(() => {
    dispatch(actions.cleanOsData());
  }, [dispatch]);

  return (
    <Header
      handleDownloadCsv={handleDownloadCsv}
      cliente={
        filtros?.empresa?.nome ? filtros?.empresa?.nome : filtros.empresaNome
      }
      inicioPeriodo={filtros.inicioPeriodo}
      fimPeriodo={filtros.fimPeriodo}
      handleClickOpenFilters={handleClickOpenFilters}
      loading={osFile.loading}
      osFile={osFile}
      handleCleanOsData={handleCleanOsData}
    />
  );
};

export default HeaderConnected;
